"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Legal;
var _react = _interopRequireDefault(require("react"));
var _images = _interopRequireDefault(require("../common_features/assets/images"));
var _LegalComponent = _interopRequireDefault(require("../components/LegalComponent"));
function Legal() {
  const onCLickPrivacy = () => {
    window.open('https://www.pentair.com/en-us/legal/privacy-notice.html', '_blank', "noopener");
  };
  const onCLickTerms = () => {
    window.open('https://www.pentair.com/en-us/legal/terms-of-use/sc-app-terms-and-conditions-en-us.html', '_blank', "noopener");
  };
  return /*#__PURE__*/_react.default.createElement(_LegalComponent.default, {
    headerText: "Legal",
    rightArrow: _images.default.ArrowRight.default,
    onCLickPrivacy: onCLickPrivacy,
    onCLickTerms: onCLickTerms
  });
}